export const MOSAIC_VERSION = '1.112.0'
